import {
  GET_BULK_PUSH_NOTIFICATION_ERROR,
  GET_BULK_PUSH_NOTIFICATION_START,
  GET_BULK_PUSH_NOTIFICATION_SUCCESS,
} from 'constants/action-types/organizations/getAllPushNotifications';

export default (state, { type, payload }) => {
  switch (type) {
    case GET_BULK_PUSH_NOTIFICATION_START:
      return {
        ...state,
        pushNotificationsList: {
          ...state.pushNotificationsList,
          loading: true,
          error: null,
        },
      };
    case GET_BULK_PUSH_NOTIFICATION_ERROR:
      return {
        ...state,
        pushNotificationsList: {
          ...state.pushNotificationsList,
          error: payload,
          loading: false,
        },
      };
    case GET_BULK_PUSH_NOTIFICATION_SUCCESS:
      return {
        ...state,
        pushNotificationsList: {
          ...state.pushNotificationsList,
          data: payload.data,
          meta: payload.meta,
          loading: false,
        },
      };
    default:
      return null;
  }
};
